// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d600dca5","453":"e021cefc","455":"dfd690cd","977":"8b7b6c44"}[chunkId] + ".chunk.js";
};